import {
  Box,
  Center,
  HStack,
  IconButton,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Spinner,
  Stack,
  Text,
} from '@chakra-ui/react';

import { NavLink as RouterLink } from 'react-router-dom';

import { format, parseISO } from 'date-fns';
import { TransactionNote, CloseCircleOutline } from '@aslanpay/portal-common-lib';

import useFetchTransactionNotes from 'app/hooks/useFetchTransactionNotes';

import { getAdminProfilePath } from 'app/utils/routes';

import { ViewTransactionNotesModalProps } from './types';

function ViewTransactionNotesModal({
  selectedIds,
  isOpen,
  onClose,
}: ViewTransactionNotesModalProps) {
  const { data: notes, isLoading: isLoadingNotes } = useFetchTransactionNotes({
    transactionIds: selectedIds,
    page: 0,
    size: 9999999,
  });

  return (
    <Modal
      isOpen={isOpen}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      onClose={onClose}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <Text as="h6">View notes</Text>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close view notes"
              onClick={onClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody>
          {isLoadingNotes ? (
            <Center width="full" height="full" flexGrow={1}>
              <Spinner color="brand.purple" size="xl" mb="50px" />
            </Center>
          ) : (
            <Stack spacing="16px">
              {notes?.list.map((note) => {
                const extendedNote = note as TransactionNote & { adminName: string };

                return (
                  <Stack key={extendedNote.id}>
                    <Box
                      minH="40px"
                      p="10px"
                      bgColor="brand.lightGray2"
                      borderRadius="6px"
                      border="1px solid"
                      borderColor="brand.lightGray1"
                      dangerouslySetInnerHTML={{ __html: extendedNote.note }}
                    />
                    <Text textAlign="right" textStyle="extraExtraSmallMedium">
                      Created by:{' '}
                      {extendedNote.createdBy === '00000000-0000-0000-0000-000000000000' ? (
                        <Text as="span" color="brand.purple">
                          {extendedNote.adminName}
                        </Text>
                      ) : (
                        <Link
                          as={RouterLink}
                          to={getAdminProfilePath(extendedNote.createdBy)}
                          color="brand.purple"
                          textDecoration="underline"
                        >
                          {extendedNote.adminName}
                        </Link>
                      )}{' '}
                      at{' '}
                      <Text as="span" color="brand.purple">
                        {format(parseISO(extendedNote.createdAt as string), 'yyyy-MM-dd HH:mm:ss')}
                      </Text>
                    </Text>
                  </Stack>
                );
              })}
            </Stack>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default ViewTransactionNotesModal;
